// initial state
import { videoManagement } from '@/api'

const state = {
  childrenAccountList: [],
  currentChildrenAccount: { // 当前选中的子账号
    cid: '', // 当前登录的cid
    proxyCid: '', // 授权登录的cid
    proxyCidDtName: '' // 授权登录的cid名称
  }
}
// getters
const getters = {}
// actions
const actions = {
  getChildrenAccountList(context, param) {
    return videoManagement.getChildrenList(param).then(({ data }) => {
      if (data.status === 0) {
        context.commit('setChildrenAccountList', { list: data.result })
      }
    })
  },
  setChildrenAccount(context, proxyCid) {
    return videoManagement.setChildrenAccount(proxyCid).then(({ data }) => {
      if (data.status === 0) {
        localStorage.setItem('account_info_key', JSON.stringify(data.result))
        context.commit('updateChildrenAccount', { list: data.result })
      }
    })
  },
  getChildrenAccount(context) {
    return videoManagement.getCurrentAccount().then(({ data }) => {
      if (data.status === 0) {
        context.commit('updateChildrenAccount', { list: data.result })
      }
    })
  },
}

// mutations
const mutations = {
  setChildrenAccountList(state, data) {
    state.childrenAccountList =  data.list
  },
  updateChildrenAccount(state, newData) {
    state.currentChildrenAccount = newData.list
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
